import React from 'react';

// Utils
import { FormattedMessageV2 } from '@/views/components/i18n';

const HistoricalScenariosFilterEmptyResults: React.FC = () => (
  <div className="filter-no-results">
    <FormattedMessageV2 toLocalize="Search.NoSearchResults.Title" />
  </div>
);

export default HistoricalScenariosFilterEmptyResults;
